import surfaceGLSL from "./utils/surface.glsl";

import normalsGLSL from "./utils/normals.glsl";

const fragmentShader = /* glsl */ `
precision highp float;

varying vec3 vNormal;
varying vec2 vUv;
varying vec3 vWorldPosition;


/*
 * Shared shader utilities.
 */
${surfaceGLSL}
${normalsGLSL}


/*
 * Lighting.
 */
uniform vec3 uLightDirection;
uniform vec3 uLightColor;

uniform float uLightIntensity;
uniform float uAmbientIntensity;


/*
 * Gooch.
 */
uniform vec3 uCoolColor;
uniform vec3 uWarmColor;

uniform float uCoolMix;
uniform float uWarmMix;


/*
 * ============================================================
 * MAIN
 * ============================================================
 */

void main() {

    vec2 surfaceUv =
        transformSurfaceUv(
            vUv
        );


    vec3 surfaceColor =
        getSurfaceColor(
            surfaceUv
        );


    float ao =
        getAmbientOcclusion(
            surfaceUv
        );


    vec3 emissive =
        getEmissiveColor(
            surfaceUv
        );


    vec3 surfaceNormal =
        getSurfaceNormal(
            surfaceUv
        );


    vec3 lightDirection =
        normalize(
            uLightDirection
        );


    /*
     * Gooch intentionally uses the
     * complete [-1, 1] N dot L range.
     */
    float nDotL =
        dot(
            surfaceNormal,
            lightDirection
        );


    /*
     * Remap [-1, 1] to [0, 1].
     *
     * 0 = cool
     * 1 = warm
     */
    float goochFactor =
        clamp(
            (
                nDotL +
                1.0
            ) *
            0.5,
            0.0,
            1.0
        );


    vec3 cool =
        uCoolColor +
        surfaceColor *
        uCoolMix;


    vec3 warm =
        uWarmColor +
        surfaceColor *
        uWarmMix;


    vec3 goochColor =
        mix(
            cool,
            warm,
            goochFactor
        );


    goochColor *=
        uLightIntensity;


    goochColor *=
        uLightColor;


    /*
     * AO affects ambient only.
     */
    vec3 ambient =
        surfaceColor *
        uAmbientIntensity *
        ao;


    vec3 finalColor =
        goochColor +
        ambient;


    finalColor +=
        emissive;


    gl_FragColor =
        vec4(
            finalColor,
            1.0
        );
}

`;

export default fragmentShader;
